export const locale = {
  lang: 'nl',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO': 'Dit is een focus area proces',
        'NO-ENCU': 'U hebt momenteel geen toegewezen enquêteprocedure',
        'ENC-AUTO': 'Authorized Survey',
        'ENC-CORRECI': 'De enquête is ter correctie verzonden',
        'MODAL_NO_COLAB_EMPRE':'U hebt uw donorbestand nog niet geüpload, weet u zeker dat u verder wilt gaan?',
      },
      'STATUS-ENCUESTA':{
        '1': 'In uitvoering',
        '2':' Evalueren',
        '3':' Geautoriseerd',
        '5': 'Correct',

      },
      'LISTA': {
        'TAB': 'Lijst van deelnemers',
        'BUSCAR': {
          'INFO': 'U kunt een of meer deelnemers uit de lijst zoeken door de naam hieronder in te typen',
          'PLACEHOLDER': 'Zoek een deelnemer'
        },
        'AGREGAR': {
          'BOTON': 'Voeg een deelnemer toe'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Voor-en achternaam',
            'EMAIL': 'E-mail',
            'ACCIONES': 'Beschikbare Acties'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Voeg een deelnemer toe aan de lijst',
          'EDITAR': 'Bewerk deze deelnemersgegevens'
        }
      },
      'MODALES':{
        'CREARENC': 'Voer de naam van de enquête in',
        'CORRECTO': 'Het is correct toegevoegd',
        'DELETE': 'Je wilt echt elimineren',
        'COMDELETE': 'Correct verwijderd',
        'RSPSI': 'JA',
        'RSPNO': 'NEE',
        'RSPOK': 'OK',
        'RSPACEPTAR': 'Accepteer',
        'CARGANDOLISTA': 'Ophalen van de deelnemerslijst, even geduld a.u.b.'

      },

      'WIZARD':{
        'CARGANDOF': 'Lading van aangekochte producten',
        'SINPRODS': 'U heeft dit product niet aangeschaft',
        'CREARENC': 'Maak een enquête',
        'GEDAAN': 'Aanmeldingsjaar: ',
        'TITULO': 'WELKOM OP AANDACHTSGEBIED',
        'TFOCUS': 'ONDERZOEK NAAR AANDACHTSGEBIED',
        'DELETE': 'Delete',
        'EDIT': 'Edit',
        'VERIPRE': 'Vragen controleren',
        'AVANCE': 'Vooruit',
        'TITUVERI': 'Controle van de vragen',
        'TITUTABTEM': 'Vragen over sjablonen',
        'TITUTABADI': 'Aangepaste vragen',
        'TITUTAUTORIZADA': 'Authorized Survey',
        'TITUTNOAUTORIZADA': 'Disauthorize Survey',
        'TITUTAUTORIZAR': 'Autoriseer onderzoek',
        'TITUTCORREGIR': 'Correcte enquête',
      },
      'TABLACAMPOS':{
        'NAME': 'Naam van de enquête',
        'FECHAI': 'Startdatum',
        'FECHAF': 'Doeldatum',
        'AVANCE': 'Vooruit',
        'ESTADO': 'Status',
        'ACCION': 'Acties',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Upload gecertificeerde medewerkers'
      },
      'GRUPOS':{
        'OK_NAME': 'De naam is correct toegevoegd',
        'BESCHRIJVING_OK': 'De beschrijving is correct toegevoegd',
      },
      'ADMIN-PREG':{
        'TITULO-ABIE': 'Open vragen',
        'PREGUN': 'Vragen',
        'PREGUNSUB': 'Vraag',
        'DESCRIP-PREGUN': 'Klik hier om de vraag te tonen',
        'TITULO-UNAOPC': 'One-choice questions',
        'TITULO-MULOPC': 'Meerkeuzevragen',
        'OPC': 'Opties',
        'OPCSUB': 'Optie',
        'NO-ADICI': 'De enquête heeft geen aanvullende vragen',
      },
      'IDIOM-NATIVO':{
        'pt':'Portugues',
        'es':'Español',
        'en':'English',
      },
      'STEP_COLAB':{
        'STEP_1':{
          'TITULO_STEP_ELEGIR_COLAB':'Selectie type van medewerkers',
          'INST_1':'Selecteer een van de volgende opties',
          'NUEVA_BASE_COLA':'Upload nieuw medewerkersbestand',
          'BASE_COLAB_EXIS':'Gebruik hoofdbestand van medewerkers',
          'BTN_SIGUENTE':'Volgende',

        },
        'STEP_2':{
          'TITULO_STEP_SUBIR_COLAB':'Selectie van contribuanten',
          'MAT_TITLE_DEMO_SELE':'Geselecteerde demografische gegevens',
          'ALERT_NOT_DEMO_SELE':'U heeft nog geen filters geselecteerd',
          'ALERT_NOT_SELE_COLAB':'Geen medewerkers toegevoegd',
          'AGREGAR_FILTRO':'Filter toevoegen',
          'TH_NOMBRE':'Naam medewerker',
          'TH_ACCION':'Acties',
          'INTS_SEL_1_O_MAS_COLAB':'*Opmerking: selecteer een of meer medewerkers',
          'SIN_RESULTADOS':'De huidige filterselectie heeft geen resultaten opgeleverd, probeer filters te wijzigen en probeer het opnieuw',
          'BTN_REGRESAR':'Terug',
          'BTN_AGRE_COLAB':'Medewerkers toevoegen',
          'BTN_GUAR_COLAB':'Bewaar medewerkers',
          'BTN_BORR_COLAB':'Medewerkers verwijderen',
          'BTN_ACEPTAR':'Accepteer',
          'BTN_BUSCAR':'Zoeken',
          'TITULO_MODAL_DEMOGRA':'Lijst van demografische gegevens',
          'MAT_TITLE_EXPA_RESULT':'Zoekresultaten voor medewerkers:',
          'MAT_TITLE_EXPA_AGREG':'Medewerkers samenvoegen:',
          'MAT_TITLE_EXPA_DESCRIP':'Zie medewerkers',
          'MODALES':{
            'MODAL_CARGAN_FILTROS':'Filters laden',
            'MODAL_BUSCA_COLAB':'Zoeken naar gefilterde medewerkers',
            'MODAL_AGRE_COLAB':'Medewerkers toevoegen',
            'MODAL_DELET_COLAB':'Informatie over medewerker verwijderen',
            'MODAL_SUCCES_AGRE_COLAB':'Medewerkers zijn succesvol toegevoegd',
            'MODAL_GUAR_COLAB':'Medewerkers opslaan',
            'MODAL_CONFIR_BORRAR_COLAB':'Weet u zeker dat u de bijdrager wilt verwijderen?',
            'MODAL_CONFIR_BORRAR_COLABRES':'Weet je zeker dat je de medewerkers wilt verwijderen?',
            'MODAL_CONFIR_GUAR_COLAB_BACK':'Weet je zeker dat je de toegevoegde medewerkers moet opslaan?',
            'MODAL_SUCCES_GUAR_COLAB':'Medewerkers zijn correct opgeslagen',
            'MODAL_SUCCES_BORRA_COLAB':'Medewerker is correct verwijderd',
            'MODAL_SUCCES_BORRA_COLABRES':'Medewerkers zijn succesvol verwijderd',
            'MODAL_WARNN_NO_SELECT_COLAB':'U heeft nog geen medewerker geselecteerd',
            'BTN_SI':'Ja',
            'BTN_NO':'Geen',
            'BTN_OK':'Ok',
          },
          'FORMULARIO':{
            'fullName': 'FULL NAME',
            'ownKey': 'WERKNEMERSNUMMER',
            'age': 'JAAR VAN GEBOORTE',
            'surveyKey': 'ENQUÊTE-TOEGANGSSLEUTEL',
            'E-mail': 'EMAIL',
            'bossName': 'DIRECT BOSS NAME',
            'bossKey': 'DIRECTE BAASNUMMER',
            'country': 'LAND',
            'location': 'LOCATIE',
            'geo_1': 'GEOGRAFISCHE NIVEAU 1',
            'geo_2': 'GEOGRAFISCHE NIVEAU 2',
            'geo_3': 'GEOGRAFISCHE NIVEAU 3',
            'geo_4': 'GEOGRAFISCHE NIVEAU 4',
            'geo_5': 'GEOGRAFISCHE NIVEAU 5',
            'geo_6': 'GEOGRAFISCHE NIVEAU 6',
            'geo_7': 'GEOGRAFISCHE NIVEAU 7',
            'geo_8': 'GEOGRAFISCHE NIVEAU 8',
            'geo_9': 'GEOGRAFISCHE NIVEAU 9',
            'geo_10': 'GEOGRAFISCHE NIVEAU 10',
            'structure_1': 'STRUCTURELE NIVEAU 1',
            'structure_2': 'STRUCTURELE NIVEAU 2',
            'structure_3': 'STRUCTURELE NIVEAU 3',
            'structure_4': 'STRUCTUURLIJKSE NIVEAU 4',
            'structure_5': 'STRUCTUURLIJKSE NIVEAU 5',
            'structure_6': 'STRUCTUURLIJKSE NIVEAU 6',
            'structure_7': 'STRUCTUURLIJKSE NIVEAU 7',
            'structure_8': 'STRUCTUURLIJKSE NIVEAU 8',
            'structure_9': 'STRUCTURELE NIVEAU 9',
            'structure_10': 'STRUCTURELE NIVEAU 10',
            'area': 'AREA',
            'bUnit': 'BUSINESS UNIT',
            'enterDate': 'DATUM VAN ENTRY TO THE COMPANY',
            'antiquity': 'ANTIQUITEIT',
            'antiquityUS': 'ANTIQUITY US',
            'generation': 'GENERATIE',
            'generationUS': 'GENERATIE VS',
            'ageUS': 'LEEFTIJD',
            'charge': 'POSITIE OF FUNCTIE IN DE VENNOOTSCHAP',
            'Homologado': 'CHARGE OR FUNCTION APPROVED',
            'homologadoUS': 'CHARGE OR FUNCTION APPROVED US',
            'gender': 'GENDER',
            'genderType': 'TYPE OF GENDER',
            'typeofwork ': 'TYPE OF COMPENSATION',
            'workCondition': 'Werkvoorwaarde',
            'academico': 'ACADEMIC DEGREE',
            'Contratacion': 'CONTRACT TYPE',
            'situacionUS': 'WORK SITUATION US',
            'personal': 'EMPLOYEE TYPE',
            'jornada': 'TYPE OF WORK SCHEDULE',
            'rotacion': 'DOES SHIFT ROTATION',
            'phone': 'COLLABORATORS PHONE',
            'extension': 'DIRECT EXTENSION OF THE COLLABORATOR',
            'cellphone': 'COLLABORATORS CELLPHONE',
            'native': 'NATIVE LANGUAGE',
            'answer': 'ANTWOORD',
            'other_1': 'Andere_1',
            'other_2': 'Andere_2',
            'other_3': 'Andere_3',
            'other_4': 'Andere_4',
            'other_5': 'Andere_5',
            'other_6': 'Andere_6',
            'other_7': 'Andere_7',
            'other_8': 'Andere_8',
            'other_9': 'Andere_9',
            'other_10': 'Andere_10',
          },
        },
    }

    }
  }
};
